export const styles = {
  scrollViewContainer: { paddingHorizontal: 12 },
  shadowIcons: { width: 0, height: 2 }
};
